import { AspectRatio, Box, Image, BoxProps } from "@chakra-ui/react";
import { publicUrl } from "config";

type EmptyFancyBearCardProps = BoxProps & {};

const EmptyFancyBearCard = ({ children, ...rest }: EmptyFancyBearCardProps) => (
  <Box bg="bright.500" p="2" w="full" userSelect="none" {...rest}>
    <AspectRatio ratio={1} w="full" bg="bright.600">
      <Image
        src={`${publicUrl}/bear-placeholder_transparent.png`}
        w="full"
        position="absolute"
        opacity={0.5}
      />
    </AspectRatio>

    <Box pt="3" px="2">
      {children}
    </Box>
  </Box>
);

export default EmptyFancyBearCard;
